import gql from 'graphql-tag';

export const SEND_FORGET_PASSWORD = gql`
  mutation sendForgotPassword($userId: Int!, $projectId: String!) {
    user {
      sendForgotPassword(userId: $userId, projectId: $projectId)
    }
  }
`;
